import React, { PropsWithChildren } from "react";
import { Box, styled } from "@mui/material";

const TemplateLayout: React.FC<PropsWithChildren<{}>> = ({ children }) => {
  return (
    <>
      <MainContainer>
        <MainContent>{children}</MainContent>
      </MainContainer>
    </>
  );
};

export default TemplateLayout;
const MainContainer = styled(Box)`
  display: flex;
`;

const MainContent = styled("main")`
  height: 100vh;
  overflow-y: auto;
  scrollbar-width: none;
  ${({ theme }) => theme.breakpoints.up("sm")} {
    width: 100vw;
  }
  ${({ theme }) => theme.breakpoints.down("sm")} {
    width: 100vw;
  }
`;
